import React from 'react';
import { translate } from '../../Services/translation';
import Icon from '../IconBase/Icon';
import BuyButton from '../BuyButton';
import { uniqueId } from 'lodash';

const StackedPrices = ({ articleNumber, tierPrices, closeButton }) => {
  const getFieldId = () => uniqueId();

  return (
    <div className="stacked-prices">
      <div className="stacked-prices__header">
        <div className="stacked-prices__title">
          {translate('product.stacked-prices-title')}
        </div>
        {closeButton}
      </div>
      {tierPrices.length > 0 && (
        <table className="stacked-prices__table">
          <thead>
            <tr className="stacked-prices__row">
              <th>{translate('product.stacked-prices-price-per-item')}</th>
              <th>{translate('product.stacked-prices-savings')}</th>
              <th>
                <div className="stacked-prices__col stacked-prices__col--right">
                  {translate('product.stacked-prices-amount')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {tierPrices.map((tierPrice) => {
              const fieldId = 'tier-' + getFieldId();
              return (
                <tr
                  key={`tierprice-${tierPrice.minimumQuantityFormatted}`}
                  className="stacked-prices__row"
                >
                  <td>{tierPrice.priceHtml}</td>
                  <td>{tierPrice.discountFormatted}</td>
                  <td>
                    <div className="stacked-prices__col stacked-prices__col--right">
                      <div className="stacked-prices__package">
                        <div className="stacked-prices__package__amount">
                          {tierPrice.quantityInPacksTotalTitle}
                        </div>
                        <div className="stacked-prices__package__info">
                          {tierPrice.minimumQuantityTitle}
                        </div>
                      </div>
                      <input
                        type="hidden"
                        id={fieldId}
                        value={tierPrice.minimumQuantity}
                      />
                      <BuyButton
                        articleNumber={articleNumber}
                        label={<Icon iconCode="shopping_cart" />}
                        cssClass="stacked-prices__buy-button"
                        quantityFieldId={fieldId}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default StackedPrices;
